import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserSignature } from '../models/user-signature.model';
import { Observable } from 'rxjs';

@Injectable()
export class ProfileUserSignatureService {
  private readonly baseUrl = '/sdapi/profile/userSignature';

  constructor(private readonly http: HttpClient) {}

  getUserSignature(pinNumber?: number): Observable<UserSignature> {
    const url = pinNumber
      ? `${this.baseUrl}/getUserSignatureByUserId?pinNumber=${pinNumber}`
      : `${this.baseUrl}/getUserSignatureByUserId`;
    return this.http.get<UserSignature>(url);
  }

  saveUserSignature(usersignature: UserSignature): Observable<boolean> {
    const url = `${this.baseUrl}/saveUserSignature`;
    return this.http.post<boolean>(url, usersignature);
  }

  deactivateUserSignature() {
    const url = `${this.baseUrl}/deactivateUserSignature`;
    return this.http.post<boolean>(url, {});
  }

  getUserSignatures(): Observable<UserSignature[]> {
    const url = `${this.baseUrl}/getUserSignatures`;
    return this.http.get<UserSignature[]>(url);
  }

  deactivateUserSignatureEmail(userSignatureId: number) {
    const url = `${this.baseUrl}/${userSignatureId}/deactivateUserSignatureEmail`;
    const emailDeactivateUrl = JSON.stringify(`${location.href}/deactivate`);
    return this.http.post<boolean>(url, emailDeactivateUrl, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  resendDeactivateUserSignatureEmail() {
    const url = `${this.baseUrl}/resendDeactivateUserSignatureEmail`;
    const emailDeactivateUrl = JSON.stringify(`${location.href}/deactivate`);
    return this.http.post<boolean>(url, emailDeactivateUrl, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  resetDeactivatePendingDate(userSignatureId: number) {
    const url = `${this.baseUrl}/resetDeactivatePendingDate`;
    return this.http.post<boolean>(url, userSignatureId, {
      headers: { 'Content-Type': 'application/json' }
    });
  }
}
